"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
import vueQr from "vue-qr";
import UiSubmit from "@/components/form/UiSubmit.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import UiDialog from "@/components/dialog/UiDialog.vue";
import ChangePhoneDialog from "@/views/managements/accountmanager/components/dialog/ChangePhoneDialog.vue";
import EditPasswordDialog from "@/views/managements/accountmanager/components/dialog/EditPasswordDialog.vue";
import ChangePayPalAccountDialog from "@/views/managements/accountmanager/components/dialog/ChangePayPalAccountDialog.vue";
import AccountCascaderDistrict from "@/views/accountItems/components/AccountCascaderDistrict.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
class TeamVerifyController extends UiFormController {
  constructor() {
    super(...arguments);
    this.password = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("accountinfo.password_cannot_be_empty"),
      trigger: "blur"
    }
  ])
], TeamVerifyController.prototype, "password", 2);
export class AccountInfoForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.name = "";
    this.email = null;
    this.password = "*********";
    this.phone = null;
    this.orgName = null;
    this.QQ = null;
    this.contact = null;
    this.addressGuid = null;
    this.paypal_account = null;
    this.phone_prefix = null;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("accountinfo.name_cannot_be_empty"),
      trigger: "blur"
    }
  ])
], AccountInfoForm.prototype, "name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      validator: (rule, value, callback) => {
        let runoob = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (value === null || value === "") {
          callback();
          return true;
        }
        let search = value.search(runoob);
        if (search < 0) {
          callback(i18n.t("accountinfo.mailbox_format_is_incorrect"));
          return false;
        }
        callback();
        return true;
      },
      trigger: "blur"
    }
  ])
], AccountInfoForm.prototype, "email", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      validator: (rule, value, callback) => {
        if (value !== null && value !== void 0 && value !== "") {
          if (value.search(/^\d*$/) < 0) {
            callback(i18n.t(`accountinfo.incorrect_format`));
            return false;
          }
        }
        callback();
        return true;
      },
      trigger: "blur"
    }
  ])
], AccountInfoForm.prototype, "QQ", 2);
let AccountMessage_default = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.formLoading = false;
    this.controller = new AccountInfoForm();
    this.bind_wechat_status = false;
    this.qrLoading = false;
    this.user_link = null;
    this.verifyController = new TeamVerifyController();
    this.verify_password = false;
    this.imageUrl = require("../../../../assets/logo-64.png");
    this.wechat_name = "";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.getAccountInfo();
      this.getWxBindLink();
    });
  }
  getAccountInfo() {
    return __async(this, null, function* () {
      try {
        this.formLoading = true;
        const response = yield API.get(
          "api://base.auth/api/v8/accounts"
        );
        this.controller.name = response.data.name;
        this.controller.phone = response.data.phone;
        this.controller.phone_prefix = response.data.phone_prefix;
        this.controller.email = response.data.email;
        this.controller.QQ = response.data.qq;
        this.controller.orgName = response.data.org_name;
        this.controller.contact = response.data.contact;
        this.controller.addressGuid = response.data.address_guid;
        this.controller.paypal_account = response.data.paypal_email;
        this.wechat_name = response.data.nick_name;
        if (this.wechat_name) {
          this.bind_wechat_status = true;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.formLoading = false;
      }
    });
  }
  openChangePhone() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(this.$t("accountinfo.change_phone_message_tips"), this.$t("accountinfo.change_phone_message_title"), {
          confirmButtonText: this.$t("accountinfo.i_know"),
          showCancelButton: false,
          type: "warning"
        });
      } catch (error) {
      } finally {
        this._changePhoneDialog.open();
      }
    });
  }
  openEditPassword() {
    return __async(this, null, function* () {
      this._edit_password_dialog.open();
    });
  }
  getWxBindLink() {
    return __async(this, null, function* () {
      try {
        this.qrLoading = true;
        const response = yield API.get(
          "api://base.auth/api/v7/wechat/drainage/bindLink"
        );
        this.user_link = response.data.link;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.qrLoading = false;
      }
    });
  }
  formSubmit() {
    return __async(this, null, function* () {
      try {
        const response = yield API.put("api://base.auth/api/v8/accounts", {
          address_guid: this.controller.addressGuid,
          contact: this.controller.contact,
          email: this.controller.email,
          name: this.controller.name,
          org_name: this.controller.orgName,
          qq: this.controller.QQ
        });
        this.$message.success(
          this.$t("accountinfo.saved_successfully")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  VerifyPassword() {
    return __async(this, null, function* () {
      try {
        let response = yield API.post(`api://base.auth/api/v1/account/orgs/show/password/valid`, {
          password: this.verifyController.password
        });
        let _valid = response.data.status;
        if (_valid === "PASSWORD_VALID_FALI") {
          this.$message.error(this.$t("accountinfo.password_input_error"));
          return;
        }
        this.verify_password = true;
        yield this.closeVerify();
      } catch (error) {
        console.log(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeVerify() {
    return __async(this, null, function* () {
      this._change_verify.hide();
      this.verifyController.password = "";
      if (this.verify_password === true) {
        const response = yield API.get(`api://base.auth/api/v7/wechat/drainage/userUnbind`);
        this.$message.success(this.$t("accountinfo.unbinding_succeeded"));
        yield this.getAccountInfo();
        yield this.getWxBindLink();
        this.bind_wechat_status = false;
        this.verify_password = false;
      }
    });
  }
  unbindWechat() {
    return __async(this, null, function* () {
      try {
        this.$confirm(this.$t("accountinfo.make_sure_you_want_to_release_the_wechat_binding_relationship_of_this_account_new") + `<br/>` + this.$t("accountinfo.make_sure_you_want_to_release_the_wechat_binding_relationship_of_this_account_"), this.$t("accountinfo.tips"), {
          confirmButtonText: this.$t("accountinfo.determine"),
          cancelButtonText: this.$t("accountinfo.cancel"),
          roundButton: true,
          dangerouslyUseHTMLString: true,
          type: "warning"
        }).then(() => __async(this, null, function* () {
          this._change_verify.show();
        })).catch(() => {
          return;
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  showChangePayPal() {
    this._change_paypal_account_dialog.open();
  }
};
__decorateClass([
  Ref("change-team-verify-dialog")
], AccountMessage_default.prototype, "_change_verify", 2);
__decorateClass([
  Ref("changePhoneDialog")
], AccountMessage_default.prototype, "_changePhoneDialog", 2);
__decorateClass([
  Ref("edit-password-dialog")
], AccountMessage_default.prototype, "_edit_password_dialog", 2);
__decorateClass([
  Ref("change-paypal-account-dialog")
], AccountMessage_default.prototype, "_change_paypal_account_dialog", 2);
AccountMessage_default = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      vueQr,
      UiDialog,
      PasswordInput,
      ChangePhoneDialog,
      EditPasswordDialog,
      ChangePayPalAccountDialog,
      AccountCascaderDistrict
    }
  })
], AccountMessage_default);
export {
  AccountMessage_default as default
};
